import type { FeedComment } from '@/types/feed.type'

import React from 'react'
import { fDateTime } from '@/utils/format-date'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'

import MediaGallery from './feed-comment-media-gallery'

// Reply Comment Component
interface ReplyCommentProps {
  comment: FeedComment
  // onReply: (comment: FeedComment) => void
  onMediaClick: (media: {
    url: string
    type: 'image' | 'gif' | 'sticker' | 'video'
  }) => void
}

const ReplyComment: React.FC<ReplyCommentProps> = ({
  comment,
  // onReply,
  onMediaClick,
}) => {
  const { imageUrl, displayName, firstName, lastName, email, role } =
    comment.user
  const name =
    firstName && lastName ? `${firstName} ${lastName}` : displayName || email

  return (
    <div className="bg-gray-50 rounded-lg p-3 space-y-2 border-l-2 border-blue-300">
      <div className="flex items-start space-x-2">
        <Avatar className="w-8 h-8">
          <AvatarImage
            className="object-cover"
            src={role !== 'ADMIN' ? imageUrl : '/images/rfc-logo.png'}
            alt={name}
          />
          {!!name && (
            <AvatarFallback className="text-xs bg-gray-100 text-gray-600">
              {role !== 'ADMIN' ? name.slice(0, 2) || '' : 'RFC'}
            </AvatarFallback>
          )}
        </Avatar>
        <div className="flex-1 min-w-0 space-y-1">
          <div className="flex flex-col items-start">
            <h5 className="text-xs font-medium text-gray-900">{name}</h5>
            <span className="text-xs text-gray-500">
              {fDateTime(comment.createdAt)}
            </span>
          </div>
          <p className="text-xs text-gray-700 break-all">{comment.content}</p>

          {/* Media Display for Reply */}
          {comment.media && (
            <div className="mt-2">
              <MediaGallery
                media={[comment.media]}
                onMediaClick={onMediaClick}
              />
            </div>
          )}

          {/* Action buttons for Reply */}
          <div className="flex items-center space-x-3 pt-1">
            {/* <button className="flex items-center space-x-1 text-xs text-muted hover:text-white transition-colors">
              <svg
                className="w-3 h-3"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
                />
              </svg>
              <span>{comment.likeCount || 0}</span>
            </button> */}
            {/* <button
              className="flex items-center space-x-1 text-xs text-muted hover:text-white transition-colors"
              onClick={() => onReply(comment)}
            >
              <svg
                className="w-3 h-3"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                />
              </svg>
              <span>ตอบกลับ</span>
            </button> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReplyComment
